/* [D-687] OWNER 20.10: «мені треба щоб у мене була в дашборді копія телефона партнера щоб я завжди міг бачити те, що бачить у себе партнер коли відкриває
   меню (Кабінет партнера)… окремо кнопка яка відкриє нове меню і там я буду бачити цю копію і мати можливість управляти нею та редагувати».
   Це СПРАВЖНІЙ кабінет партнера (/miniapp/partner?as=<id>) - ті самі дані й кнопки, що в партнера; вхід - ваш вхід у дашборд (лише власник).
   Усе, що тут зробите, - справжні дії, у журналі партнера вони записуються на ВАС (через «owner»), не на партнера.
   [D-689] OWNER 20.10: «натиск у партнера на (як учень)… щоб я міг відкрити так само телефон учня і бачити меню надане учням партнера… поруч» -
   «👀 Як учень» у кабінеті надсилає сюди, якого учня показати, і поруч відкривається «📱 Телефон учня»: меню бота і Студія учня.
   [D-690] OWNER 20.10: «якщо обрали (як новий) то одразу в клоні що бачить юзер у себе на екрані коли робить перший вхід як новий. А якщо обрали (як існуючий)
   то нехай у клоні одразу відкривається телефон як ми робили який відкривається у дашборді у кожного юзера» - одразу Студія: новий - перший вхід (вітання
   «▶ Як це працює? / Пропустити»), з пакетом - звичайна Студія учня; «🤖 Меню бота» лишається другою кнопкою. */
import React, { useEffect, useRef, useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import api from '../api';

const DEVICES = [['📱', 'iPhone', 390, 844], ['🤖', 'Android', 412, 915], ['📱', 'Малий телефон', 360, 740]];
const TG = { bg: '#0e1621', bubble: '#182533', kb: '#232e3c', txt: '#f5f5f5', dim: '#8b9aa8', link: '#6ab3f3' };

function Frame({ w, h, scale, children }) {
  return (
    <Box sx={{ width: w * scale + 12, height: h * scale + 12, boxSizing: 'border-box', borderRadius: '30px', border: '6px solid #1c2530',
               overflow: 'hidden', boxShadow: '0 10px 40px rgba(0,0,0,.5)', bgcolor: '#0b131b' }}>
      <Box sx={{ width: w, height: h, transform: `scale(${scale})`, transformOrigin: '0 0' }}>{children}</Box>
    </Box>
  );
}

/* [D-764] Q-101 OWNER 28.10: «🤖 Меню бота» - точна копія чату. Це СПРАВЖНІЙ бот: кроки учня проганяє двійник бота на сервері
   (той самий код і ті самі обробники, уявний учень цього партнера; нічого не надсилається й не зберігається). Кнопки натискаються:
   кожен натиск - ще один крок, бот проходить усю розмову з початку і показує, що відповів би. */
const ESC = { '&lt;': '<', '&gt;': '>', '&amp;': '&', '&quot;': '"', '&#39;': "'", '&#x27;': "'" };
const unesc = (t) => String(t || '').replace(/&(lt|gt|amp|quot|#39|#x27);/g, (m) => ESC[m] || m);
const TAGS = { b: { fontWeight: 700 }, strong: { fontWeight: 700 }, i: { fontStyle: 'italic' }, em: { fontStyle: 'italic' }, u: { textDecoration: 'underline' },
               ins: { textDecoration: 'underline' }, s: { textDecoration: 'line-through' }, strike: { textDecoration: 'line-through' }, del: { textDecoration: 'line-through' },
               code: { fontFamily: 'monospace', background: 'rgba(255,255,255,.08)', borderRadius: 4, padding: '0 3px' }, a: { color: TG.link },
               pre: { display: 'block', fontFamily: 'monospace', background: 'rgba(255,255,255,.08)', borderRadius: 6, padding: '6px 8px', margin: '4px 0' },
               blockquote: { display: 'block', borderLeft: '3px solid ' + TG.link, paddingLeft: 8, margin: '4px 0' }, 'tg-spoiler': { filter: 'blur(3px)' } };
function richHtml(text) {   // HTML-розмітка Telegram: лише безпечні теги, решта - як текст
  const out = []; const stack = [{ tag: null, kids: out }]; const re = /<(\/?)([a-z][a-z0-9-]*)([^>]*)>/gi; let last = 0; let m; let k = 0;
  const push = (node) => stack[stack.length - 1].kids.push(node);
  while ((m = re.exec(text))) {
    if (m.index > last) push(unesc(text.slice(last, m.index)));
    last = re.lastIndex;
    const tag = m[2].toLowerCase();
    if (!TAGS[tag] && tag !== 'span' && tag !== 'br') { push(m[0]); continue; }
    if (tag === 'br') { push('\n'); continue; }
    if (!m[1]) { const fr = { tag, kids: [], spoiler: /tg-spoiler/.test(m[3]) }; stack.push(fr); continue; }
    if (stack.length > 1) { const fr = stack.pop(); push(<span key={'h' + (k++)} style={TAGS[fr.tag] || (fr.spoiler ? TAGS['tg-spoiler'] : undefined)}>{fr.kids}</span>); }
  }
  if (last < text.length) push(unesc(text.slice(last)));
  while (stack.length > 1) { const fr = stack.pop(); stack[stack.length - 1].kids.push(<span key={'h' + (k++)} style={TAGS[fr.tag]}>{fr.kids}</span>); }
  return out;
}
function richMd(text) {     // Markdown (старий) Telegram: *жирний*, _курсив_, `код`, [текст](посилання)
  const out = []; const re = /(\*[^*\n]+\*|_[^_\n]+_|`[^`\n]+`|\[[^\]\n]+\]\([^)\n]+\))/g; let last = 0; let m; let k = 0;
  while ((m = re.exec(text))) {
    if (m.index > last) out.push(text.slice(last, m.index));
    const t = m[0]; last = re.lastIndex;
    if (t[0] === '*') out.push(<b key={'m' + (k++)}>{t.slice(1, -1)}</b>);
    else if (t[0] === '_') out.push(<i key={'m' + (k++)}>{t.slice(1, -1)}</i>);
    else if (t[0] === '`') out.push(<span key={'m' + (k++)} style={TAGS.code}>{t.slice(1, -1)}</span>);
    else out.push(<span key={'m' + (k++)} style={TAGS.a}>{t.slice(1, t.indexOf(']'))}</span>);
  }
  if (last < text.length) out.push(text.slice(last));
  return out;
}
const rich = (text, pm) => (/^html$/i.test(pm || '') ? richHtml(String(text || '')) : /^markdown/i.test(pm || '') ? richMd(String(text || '')) : String(text || ''));
const MEDIA = { photo: '🖼 фото', video: '🎞 відео', animation: '🎞 анімація', document: '📄 файл', audio: '🎵 аудіо', voice: '🎤 голосове', sticker: '🙂 стікер' };

function BotChat({ p, stu, d, onStudio }) {
  const [steps, setSteps] = useState([{ t: 'start' }]);
  const [res, setRes] = useState(null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const [note, setNote] = useState('');
  const box = useRef(null);
  useEffect(() => {
    let dead = false;
    setBusy(true); setErr(''); setNote('');
    api.post(`/partners/${p.id}/bot-as/${stu.pkg || 0}`, { steps })
      .then(r => { if (!dead) setRes(r.data); })
      .catch(e => { if (!dead) setErr((e.response && e.response.data && e.response.data.detail) || 'Двійник бота не відповів - спробуйте ще раз.'); })
      .finally(() => { if (!dead) setBusy(false); });
    return () => { dead = true; };
  }, [steps, p.id, stu.pkg]);
  useEffect(() => { const b = box.current; if (b) b.scrollTop = b.scrollHeight; }, [res]);
  const add = (st) => { if (!busy) setSteps(s => [...s, st]); };
  const tapInline = (b, mid) => {
    if (b.data) add({ t: 'cb', v: b.data, mid });
    else if (b.webapp) { setNote('Ця кнопка відкриває Студію - вона в «🎬 Студія» вгорі.'); onStudio && onStudio(); }
    else if (b.url) setNote('Кнопка відкриває посилання: ' + b.url);
  };
  const chat = (res && res.chat) || [];
  const kb = (res && res.keyboard) || [];
  const pill = { minWidth: 0, px: 1, py: .3, fontSize: 12, textTransform: 'none', color: TG.dim, border: '1px solid #2b3a4a', borderRadius: '8px' };
  return (
    <Box data-botchat="1" sx={{ height: '100%', bgcolor: TG.bg, display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ p: '10px 14px', bgcolor: '#17212b', color: TG.txt, fontWeight: 800, fontSize: 15, borderBottom: '1px solid #0b1118' }}>
        🤖 {res && res.bot ? '@' + res.bot : 'Бот'}
        <Box sx={{ fontSize: 11.5, color: TG.dim, fontWeight: 500 }}>
          {d && d.mode === 'pkg' ? 'учень «' + d.partner.name + '» з пакетом «' + d.package.name + '»' : 'новий учень «' + ((d && d.partner.name) || '') + '» - відкрив посилання'}
          {busy ? ' · бот думає…' : ''}
        </Box>
      </Box>
      <Box ref={box} sx={{ flex: 1, overflowY: 'auto', p: 1.2, display: 'flex', flexDirection: 'column', gap: .8 }}>
        {chat.map((m, i) => m.kind === 'user' ? (
          <Box key={i} data-botchat-user="1" sx={{ alignSelf: 'flex-end', maxWidth: '80%', bgcolor: '#2b5278', color: TG.txt, borderRadius: '14px 14px 4px 14px', p: '7px 11px', fontSize: 14 }}>{m.text}</Box>
        ) : m.kind === 'toast' ? (
          <Box key={i} sx={{ alignSelf: 'center', maxWidth: '86%', bgcolor: 'rgba(0,0,0,.45)', color: TG.txt, borderRadius: '10px', p: '5px 10px', fontSize: 12.5, textAlign: 'center' }}>{m.text}</Box>
        ) : (
          <Box key={i} data-botchat-bot="1" sx={{ alignSelf: 'flex-start', maxWidth: '88%' }}>
            <Box sx={{ bgcolor: TG.bubble, color: TG.txt, borderRadius: '14px 14px 14px 4px', p: '8px 11px', fontSize: 14, lineHeight: 1.45, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
              {m.media && <Box sx={{ fontSize: 12.5, color: TG.dim, mb: m.text ? .5 : 0 }}>[{MEDIA[m.media] || m.media}]</Box>}
              {rich(m.text, m.pm)}
              {m.edited && <span style={{ color: TG.dim, fontSize: 11 }}> · змінено</span>}
            </Box>
            {(m.inline || []).map((row, r) => (
              <Box key={r} sx={{ display: 'grid', gridTemplateColumns: `repeat(${row.length}, 1fr)`, gap: .5, mt: .5 }}>
                {row.map((b, j) => (
                  <Box key={j} component="button" data-botchat-inline="1" onClick={() => tapInline(b, m.id)}
                       sx={{ bgcolor: 'rgba(106,179,243,.14)', color: TG.link, border: '1px solid rgba(106,179,243,.35)', borderRadius: '8px', p: '7px 6px',
                             fontSize: 13, fontWeight: 600, cursor: busy ? 'wait' : 'pointer', font: 'inherit' }}>
                    {b.text}{b.webapp ? ' ↗' : b.url ? ' 🔗' : ''}
                  </Box>
                ))}
              </Box>
            ))}
          </Box>
        ))}
        {err && <Typography sx={{ color: '#ff7a59', fontSize: 12.5 }}>{err}</Typography>}
        {res && (res.errors || []).length > 0 && <Typography sx={{ color: '#ff7a59', fontSize: 11.5 }}>Бот: {res.errors.join('; ')}</Typography>}
        {note && <Typography sx={{ color: TG.dim, fontSize: 12 }}>{note}</Typography>}
        {res && (res.side || []).length > 0 && (
          <Typography data-botchat-side="1" sx={{ color: TG.dim, fontSize: 11.5, borderTop: '1px dashed #2b3a4a', pt: .6 }}>
            Бот також написав би: {res.side.map(x => x.to + ' - «' + String(x.text).slice(0, 120) + '»').join('; ')}
          </Typography>
        )}
      </Box>
      {kb.length > 0 && (
        <Box sx={{ bgcolor: '#17212b', p: .6, display: 'flex', flexDirection: 'column', gap: .5 }}>
          {kb.map((row, r) => (
            <Box key={r} sx={{ display: 'grid', gridTemplateColumns: `repeat(${row.length}, 1fr)`, gap: .5 }}>
              {row.map((b, j) => (
                <Box key={j} component="button" data-botchat-key="1" onClick={() => (b.webapp ? tapInline(b) : add({ t: 'text', v: b.text }))}
                     sx={{ bgcolor: TG.kb, color: TG.txt, border: 0, borderRadius: '8px', p: '9px 6px', fontSize: 13.5, fontWeight: 600, cursor: busy ? 'wait' : 'pointer', font: 'inherit' }}>
                  {b.text}
                </Box>
              ))}
            </Box>
          ))}
        </Box>
      )}
      <Box sx={{ display: 'flex', gap: .6, p: .7, bgcolor: '#0b131b', borderTop: '1px solid #17212b' }}>
        <Button size="small" data-botchat-video="1" disabled={busy} onClick={() => add({ t: 'video' })} sx={pill}>🎬 Надіслати відео</Button>
        <Button size="small" disabled={busy || steps.length < 2} onClick={() => setSteps(s => s.slice(0, -1))} sx={pill}>↶ Крок назад</Button>
        <Button size="small" disabled={busy} onClick={() => setSteps([{ t: 'start' }])} sx={pill}>⟲ Спочатку</Button>
      </Box>
    </Box>
  );
}

function StudentPhone({ p, C, stu, dev, scale, onClose }) {
  const [d, setD] = useState(null);
  const [view, setView] = useState('studio');   // [D-690] одразу Студія
  useEffect(() => {
    setD(null); setView('studio');
    api.get(`/partners/${p.id}/student-phone`, { params: { pkg: stu.pkg || 0 } }).then(r => setD(r.data)).catch(() => setD(false));
  }, [p.id, stu.pkg, stu.k]);
  const [, , devW, devH] = DEVICES[dev];
  const studioOk = !!(d && d.partner.studio);   // [D-690] і новому учню - Студія, як при першому вході
  const shown = studioOk ? view : 'bot';
  const pill = (on) => ({ minWidth: 0, px: .9, py: .1, fontSize: 12.5, textTransform: 'none', color: on ? '#04121a' : C.dim, bgcolor: on ? C.neon : 'transparent',
                          border: `1px solid ${on ? C.neon : C.line}`, '&:hover': { bgcolor: on ? C.neon : 'rgba(0,229,160,.08)' } });
  return (
    <Box data-stuphone="1" sx={{ flex: 'none', width: devW * scale + 12 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: .6, mb: .8, flexWrap: 'wrap' }}>
        <Typography sx={{ fontSize: 13, fontWeight: 800, color: C.txt, flex: 1, minWidth: 0 }}>📱 Телефон учня</Typography>
        {studioOk && <Button size="small" data-stuphone-view="studio" onClick={() => setView('studio')} sx={pill(shown === 'studio')}>🎬 Студія</Button>}
        <Button size="small" data-stuphone-view="bot" onClick={() => setView('bot')} sx={pill(shown === 'bot')}>🤖 Меню бота</Button>
        <Button size="small" title="Закрити телефон учня" onClick={onClose} sx={pill(false)}>✕</Button>
      </Box>
      <Frame w={devW} h={devH} scale={scale}>
        {d === null && <Typography sx={{ color: C.dim, p: 3, textAlign: 'center' }}>Завантажую…</Typography>}
        {d === false && <Typography sx={{ color: C.coral, p: 3, textAlign: 'center' }}>Не вдалося завантажити. Натисніть «👀 Як учень» ще раз.</Typography>}
        {d && shown === 'bot' && <BotChat key={'bc' + stu.k + '-' + (stu.pkg || 0)} p={p} stu={stu} d={d} onStudio={studioOk ? () => setView('studio') : null} />}
        {d && shown === 'studio' && (
          <iframe key={'st' + stu.k} title="Студія очима учня" data-stuphone-frame="1"
                  src={`/miniapp/studio?demo=${p.id}${stu.pkg ? '&pkg=' + stu.pkg : '&first=1'}&v=${stu.k}`}
                  style={{ width: devW, height: devH, border: 0, display: 'block' }} />
        )}
      </Frame>
      {d && <Typography sx={{ fontSize: 11.5, color: C.dim, mt: .8, lineHeight: 1.45 }}>
        {d.mode === 'pkg' ? 'Учень із пакетом «' + d.package.name + '»: Студія й меню з функціями, які дав партнер (і ви - партнеру), мінус закрите пакетом. '
                          : 'Новий учень: Студія при першому вході (вітання й «▶ Як це працює?»); у «🤖 Меню бота» - що він бачить до оплати. '}
        Студія рахується тим самим кодом, що в справжнього учня: сервер на мить створює уявного учня так само, як партнеру вмикається режим учня,
        і нічого не зберігає (збіг щодня перевіряє звіряльник). Особистих налаштувань окремого учня тут немає; обробка не запускається.
        «🤖 Меню бота» - справжній бот (той самий код і кнопки, двійник на сервері): натискайте кнопки, надсилайте відео - нічого не надсилається й не зберігається.
      </Typography>}
    </Box>
  );
}

export default function PartnerPhone({ p, C }) {
  const [dev, setDev] = useState(0);
  const [n, setN] = useState(0);
  const [stu, setStu] = useState(null);   // [D-689] { mode, pkg, k } - відкритий телефон учня
  const [vh, setVh] = useState(window.innerHeight || 900);
  const [vw, setVw] = useState(window.innerWidth || 1200);
  useEffect(() => {
    const on = () => { setVh(window.innerHeight || 900); setVw(window.innerWidth || 1200); };
    window.addEventListener('resize', on);
    return () => window.removeEventListener('resize', on);
  }, []);
  useEffect(() => {   // [D-689] «👀 Як учень» у кабінеті → телефон учня поруч
    const on = (e) => {
      if (e.origin !== window.location.origin || !e.data || e.data.type !== 'pcab-student' || String(e.data.pid) !== String(p.id)) return;
      setStu({ mode: e.data.mode, pkg: Number(e.data.pkg) || 0, k: Date.now() });
    };
    window.addEventListener('message', on);
    return () => window.removeEventListener('message', on);
  }, [p.id]);
  const [, , devW, devH] = DEVICES[dev];
  const scale = Math.max(0.45, Math.min(1, (vh - 170) / devH, (vw - 48) / devW));
  const src = `/miniapp/partner?as=${p.id}&v=${n}`;
  const pill = (on) => ({ minWidth: 0, px: .8, py: .1, fontSize: 12.5, textTransform: 'none', color: on ? '#04121a' : C.dim, bgcolor: on ? C.neon : 'transparent',
                          border: `1px solid ${on ? C.neon : C.line}`, '&:hover': { bgcolor: on ? C.neon : 'rgba(0,229,160,.08)' } });
  return (
    <Box data-pphone="1" sx={{ display: 'flex', gap: 2.5, alignItems: 'flex-start', flexWrap: 'wrap' }}>
      <Box sx={{ flex: 'none', width: devW * scale + 12 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: .6, mb: .8, flexWrap: 'wrap' }}>
          <Typography sx={{ fontSize: 13, fontWeight: 800, color: C.txt, flex: 1, minWidth: 0 }}>📱 Кабінет очима партнера</Typography>
          {DEVICES.map(([ic, t], i) => (
            <Button key={t} size="small" title={t} data-pphone-dev={i} onClick={() => setDev(i)} sx={pill(dev === i)}>{ic}{i === 2 ? 's' : ''}</Button>
          ))}
          <Button size="small" title="Перезавантажити" data-pphone-reload="1" onClick={() => setN(x => x + 1)} sx={pill(false)}>⟳</Button>
          <Button size="small" title="Відкрити окремо на весь екран" component="a" href={src} target="_blank" rel="noopener" sx={pill(false)}>↗</Button>
        </Box>
        <Box sx={{ width: devW * scale + 12, height: devH * scale + 12, boxSizing: 'border-box', borderRadius: '30px', border: '6px solid #1c2530',
                   overflow: 'hidden', boxShadow: '0 10px 40px rgba(0,0,0,.5)', bgcolor: '#0b131b' }}>
          <iframe key={n + '-' + dev + '-' + p.id} title={'Кабінет партнера «' + p.name + '»'} data-pphone-frame="1" src={src}
                  style={{ width: devW, height: devH, border: 0, display: 'block', transform: `scale(${scale})`, transformOrigin: '0 0' }} />
        </Box>
      </Box>
      {stu && <StudentPhone p={p} C={C} stu={stu} dev={dev} scale={scale} onClose={() => setStu(null)} />}
      <Box sx={{ flex: 1, minWidth: 240, maxWidth: 520 }}>
        <Box sx={{ p: 1.5, borderRadius: 2, border: `1px solid ${C.line}`, bgcolor: 'rgba(0,229,160,.05)', mb: 1.5 }}>
          <Typography sx={{ fontSize: 14, fontWeight: 800, color: C.neonTxt, mb: .6 }}>Що це</Typography>
          <Typography sx={{ fontSize: 13, color: C.txt, lineHeight: 1.55 }}>
            Справжній «Кабінет партнера» «{p.name}» - рівно те, що бачить партнер у себе в телефоні: ті самі вкладки, учні, оплати, матеріали й налаштування.
            Гортайте, відкривайте й міняйте, як партнер. «👀 Як учень» відкриє поруч телефон учня - меню бота і Студію учня.
          </Typography>
        </Box>
        <Box sx={{ p: 1.5, borderRadius: 2, border: `1px solid ${C.warn}`, bgcolor: 'rgba(255,183,77,.06)', mb: 1.5 }}>
          <Typography sx={{ fontSize: 14, fontWeight: 800, color: C.warn, mb: .6 }}>⚠️ Дії справжні</Typography>
          <Typography sx={{ fontSize: 13, color: C.txt, lineHeight: 1.55 }}>
            Усе, що тут змінюєте (підтвердження оплат, ціни, функції учнів, матеріали), - змінюється по-справжньому, у партнера теж.
            У журналі партнера такі дії записані на вас («owner»), а не на партнера. Вхід партнера, його сесії й режим «учень» це вікно не чіпає.
          </Typography>
        </Box>
        <Typography sx={{ fontSize: 12, color: C.dim, lineHeight: 1.5 }}>
          ⟳ - оновити, 📱 / 🤖 / 📱s - розмір екрана, ↗ - відкрити кабінет окремою вкладкою на весь екран.
        </Typography>
      </Box>
    </Box>
  );
}
